export default "__VITE_ASSET__DHvH9o2f__"